import { type ServiceSection } from "../types";
import { getCloudinaryUrl } from "@/lib/cloudinary";

export const headSpaService: ServiceSection = {
  id: "head-spa",
  bannerImage: getCloudinaryUrl("head-spa"),
  bannerTitle: "Head Spa",
  keywords: [
    "head spa villejuif",
    "massage crânien val de marne",
    "rituel capillaire 94800",
    "relaxation head spa",
    "bien-être villejuif",
    "l'instant grey",
  ],
  firstSection: {
    imagePath: getCloudinaryUrl("head-spa"),
    title: "Head Spa : Rituel Bien-être à Villejuif (94)",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Le Head Spa, proposé à L'Instant Grey à Villejuif, est une expérience de bien-être haut de gamme. Nos praticiennes expertes vous offrent un rituel japonais de relaxation profonde reconnu dans le Val-de-Marne.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "Dans notre espace dédié à Villejuif, nos spécialistes analysent votre cuir chevelu et vos besoins spécifiques. Le Head Spa combine techniques de massage crânien, soins capillaires naturels et rituels énergétiques pour un résultat sur mesure.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          { text: "Notre promesse", isBold: true },
          {
            text: " : un moment de reconnexion profonde, un esprit apaisé et un bien-être durable, pour vous sentir ressourcé(e) et en harmonie.",
          },
        ],
      },
    ],
  },
  secondSection: {
    title: "Notre prestation Head Spa",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Avec le Head Spa, chaque étape est pensée pour révéler votre bien-être intérieur. Peu importe vos besoins du moment, nous adaptons nos soins et techniques pour garantir une expérience exceptionnelle.",
          },
        ],
      },
      {
        type: "list",
        segments: [{ text: "Nos étapes incluent :" }],
        items: [
          "Diagnostic personnalisé : analyse du cuir chevelu et identification de vos besoins",
          "Massage crânien profond : techniques japonaises pour une relaxation optimale",
          "Soins adaptés : application de produits naturels selon votre profil",
        ],
      },
    ],
  },
  thirdSection: {
    title: "Pourquoi choisir le Head Spa ?",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Le Head Spa va au-delà d'un simple soin de beauté. Il s'agit d'un rituel qui apporte détente, reconnexion et sérénité. Nos praticiennes sont formées pour vous offrir une expérience complète, adaptée à vos besoins émotionnels et physiques.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "Que vous recherchiez l'apaisement du stress, l'amélioration du sommeil ou simplement un moment pour vous, le Head Spa apporte détente profonde et revitalisation. C'est l'occasion de vous reconnecter à vous-même dans un cadre bienveillant.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "À L'Instant Grey, nous utilisons des produits naturels et des huiles essentielles, sélectionnés pour leurs vertus apaisantes et régénérantes, garantissant ainsi un résultat durable.",
          },
        ],
      },
    ],
  },
};
